import axios from "./axios"

function create(data) {
    return axios().post("/supplier-accounts", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/supplier-accounts/${data.id}`, data);
}

function remove(data) {
    return axios().delete(`/supplier-accounts/${data.id}`);
}

function findByID(id) {
    return axios().get(`/supplier-accounts/${id}`, {
        params: {
            relations: ["supplier"]
        }
    });
}

export default {
    create,
    update,
    findByID,
    remove
}